// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/settings.css
 ** module id = 207
 ** module chunks = 0
 **/